// Vendors
import React from 'react';
import { ReloadedProvider } from '@openbank/ziniaweb-ui-components';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
// Constants
import { THEME_PROVIDER_PROPS } from './constants/bootstrap.constants';
// Components
import { EntrypointComponent } from 'entrypoint/entrypoint.component';
// Contexts
import { AppContextProvider } from 'contexts/app.context';
import { AppInformationContextProvider } from 'contexts/app-information.context';
// Providers
import { AppInformationProvider } from 'providers/app-information/app-information.provider';
import { CheckoutProvider } from 'providers/checkout/checkout.provider';
import { ErrorProvider } from 'providers/error/error.provider';
import { InternationalizationProvider } from 'providers/internationalization/internationalization.provider';
import { TokenProvider } from 'providers/token/token.provider';
import { SessionExpireProvider } from 'providers/session-expire/session-expire.provider';

const Bootstrap = (): any => {
  localStorage.setItem('locale', 'es-ES');
  localStorage.setItem('language', 'es-ES');

  createRoot(document.getElementById('root') as HTMLElement).render(
    <ReloadedProvider {...THEME_PROVIDER_PROPS}>
      <ErrorBoundary FallbackComponent={() => null}>
        <AppInformationContextProvider>
          <InternationalizationProvider>
            <ErrorBoundary FallbackComponent={ErrorProvider}>
              <AppContextProvider>
                <TokenProvider>
                  <CheckoutProvider>
                    <AppInformationProvider>
                      <SessionExpireProvider>
                        <EntrypointComponent />
                      </SessionExpireProvider>
                    </AppInformationProvider>
                  </CheckoutProvider>
                </TokenProvider>
              </AppContextProvider>
            </ErrorBoundary>
          </InternationalizationProvider>
        </AppInformationContextProvider>
      </ErrorBoundary>
    </ReloadedProvider>
  );
};

export { Bootstrap };
